import type { FaireProductEntity } from "../../entity_types/product";

export const p_lqbmq8pkm3: FaireProductEntity = {
  token: "p_lqbmq8pkm3",
  type: "product",
  name: "Love You Mom - Letterpress Mother's Day Greeting Card",
  brandToken: "b_a55ea308",
  brandName: "Dahlia Press",
  imageUrl:
    "https://cdn.faire.com/fastly/815adb2bcb60d9d388295974d28a5d687f0ff46e7241fb53b0aeb8ade9765d6b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e36779ef2e9b35fa874b02274396fea0cfac549709392c24f75abcd7b28e2ba9.jpeg",
  ],
  priceDollars: 4.11,
  description:
    "BRIGHTEN MOM'S DAY WITH THIS SWEET CARD!\nCelebrate the special bond between mother and child with this charming Mother's Day card. The elegant, hand-drawn lettering in a soft, peachy hue is accented by delicate starbursts, creating a heartwarming sentiment. This card is the perfect way to express your love and appreciation for Mom on her special day.\n\nBlank inside for your personal message, this greeting is hand illustrated, letterpress printed on plush paper and comes with a coordinating envelope.\n\nincludes: 1 card + 1 envelope // size: 4.25 x 5.5\" folded // packaging: cellophane sleeve // interior: blank // minimum: 6 per design style // Made in the USA",
  tags: [],
  msrpDollars: 8.22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:46.387Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
